import withAppProviders from "@/withAppProviders.tsx";
import { Outlet } from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { GlobalLoading } from "react-global-loading";
import { Alert } from "@/components/ui/alert.tsx";
import { Suspense } from "react";
import { Spinner } from "@/components/ui/spinner.tsx";
import ScrollToTopButton from "@/components/ScrollToTopButton.tsx";

function App() {
    return (
        <Suspense fallback={<Spinner />}>
            {import.meta.env.mode !== "prod" && <ReactQueryDevtools />}
            <div className="flex w-full justify-center">
                <div className="w-full max-w-screen-xl">
                    <Outlet />
                </div>
            </div>
            <GlobalLoading />
            <Alert />
            <ScrollToTopButton />
        </Suspense>
    );
}

export default withAppProviders(App);